module.exports = __webpack_public_path__ + "img/logo-trackunit.013fa3a8.png";